var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "input input--text", class: _vm.inputClass },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.currentValue,
            expression: "currentValue",
          },
        ],
        attrs: {
          type: "text",
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
          required: _vm.required,
        },
        domProps: { value: _vm.currentValue },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.currentValue = $event.target.value
          },
        },
      }),
      _vm.labelText ? _c("label", [_vm._v(_vm._s(_vm.labelText))]) : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }